const startDate = new Date("2011-09-07T12:00:00");
const counter = document.getElementsByClassName("counter");
if (counter.length >= 1) {
  function updateCountup() {
    const now = new Date();
    const timeDiff = now - startDate;

    const years = Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 365));
    const weeks = Math.floor(
      (timeDiff % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24 * 7)
    );
    const hours = Math.floor(
      (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    document.querySelector(".years").textContent = years;
    document.querySelector(".weeks").textContent = weeks;
    document.querySelector(".hours").textContent = hours;
    document.querySelector(".seconds").textContent = seconds;
  }

  // Update the countup every second
  setInterval(updateCountup, 1000);
  updateCountup();
}
